import React from 'react'
import { CardBox } from './CustomCard'

export default function ProductCard({ children,extraClass }) {
    return (
        <>
            <CardBox extraClass={`h-full ${extraClass}`}>
                {children}
            </CardBox>
        </>
    )
}
